import React from 'react';
import {Td, TdGradient, Tr} from "../StatisticDesign";

const StatisticTableRow = ({Floors, Dates}) => {
    // console.log(Floors)
    return(
        <>
            {
                Object.keys(Floors)
                    .map(Floor =>{
                    return (
                        <>
                            <Tr>
                                <Td>
                                    {Floor}
                                </Td>
                            </Tr>
                            {
                                Object.keys(Floors[Floor].ProgressWorks)
                                    .map(ProgressWorkType => {
                                    return (
                                        <>
                                            <Tr>
                                                <Td/>
                                                <Td>
                                                    {ProgressWorkType}
                                                </Td>
                                            </Tr>
                                            <>
                                                {
                                                    Object.keys(Floors[Floor].ProgressWorks[ProgressWorkType])
                                                        .map(ProgressWork => {

                                                            const values =
                                                                Floors[Floor].ProgressWorks[ProgressWorkType][ProgressWork];

                                                            return (
                                                                <Tr key={ProgressWork}>
                                                                    <Td />
                                                                    <Td />

                                                                    <Td>
                                                                        {ProgressWork}
                                                                    </Td>

                                                                    {Dates.map(CurrentDate => {

                                                                        const value = values.find(
                                                                            item =>
                                                                                item.Data === CurrentDate &&
                                                                                Number(item.Percent) !== 0
                                                                        );

                                                                        return value ? (
                                                                            <TdGradient
                                                                                key={CurrentDate}
                                                                                value={Number(value.Percent)}
                                                                            >
                                                                                {value.Percent}
                                                                            </TdGradient>
                                                                        ) : (
                                                                            <Td key={CurrentDate} />
                                                                        );
                                                                    })}
                                                                </Tr>
                                                            );
                                                        })
                                                }
                                            </>
                                        </>
                                    )
                                })
                            }
                        </>)
                })
            }
        </>
    )

};

export default StatisticTableRow;